import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M11.478 1.568a1.114 1.114 0 0 0-.379-1.353 1.16 1.16 0 0 0-1.425.063L.531 8.153c-.357.31-.485.805-.317 1.241s.596.731 1.071.731h3.982l-2.746 6.307a1.114 1.114 0 0 0 .378 1.354 1.16 1.16 0 0 0 1.425-.063l9.143-7.875c.357-.31.486-.805.318-1.241a1.145 1.145 0 0 0-1.072-.728H8.732z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }